
import {
  StockTransactionDto,
  CreateStockTransactionDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type StockTransactionsFilters = PaginatedQueryBase

class StockTransactionService extends BaseCrudService<
  StockTransactionDto,
  CreateStockTransactionDto,
  {},
  StockTransactionsFilters
> {
  constructor() {
    super('stock-transaction', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const stockTransactionService = new StockTransactionService()
